import React, {useImperativeHandle} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {connect} from "react-redux";
import {updateMachine} from "../../store/actions/machineActions";

const UpdateMachine = React.forwardRef((props, ref) => {

    const [open, setOpen] = React.useState(false);
    const [id, setId] = React.useState("");
    const [name, setName] = React.useState("");
    const [registerNumber, setRegisterNumber] = React.useState("");

    useImperativeHandle(ref, () => ({
        handleOpen(item) {
            setOpen(true);
            setId(item.id);
            setName(item.name);
            setRegisterNumber(item.registerNumber);
        }
    }));

    const handleClose = () => setOpen(false);
    const handleUpdate = () => {
        props.updateMachine(id, {name, registerNumber});
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Päivitä työkonetta</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Nimi"
                    type="text"
                    fullWidth
                    value={name}
                    onChange={event => setName(event.target.value)}
                />
                <TextField
                    margin="dense"
                    id="registerNumber"
                    label="Rekisterinumero"
                    type="text"
                    fullWidth
                    value={registerNumber}
                    onChange={event => setRegisterNumber(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Sulje
                </Button>
                <Button onClick={handleUpdate} color="primary">
                    Tallenna
                </Button>
            </DialogActions>
        </Dialog>
    );

});


const mapDispatchToProps = (dispatch) => {
    return {
        updateMachine: (id, machine) => dispatch(updateMachine(id, machine))
    }
};
export default connect(null, mapDispatchToProps, null, {forwardRef: true})(UpdateMachine);